import { ConfirmDialog } from '@/components/confirm-dialog'
import { listDepartmentsWithRelationsQuery } from '@/queries/department.query'
import { DepartmentService } from '@/services/department.service'
import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { toast } from 'sonner'
import { useDepartments } from '../context/departments-context'
import { DepartmentsMutateDrawer } from './departments-mutate-drawer'

export function DepartmentsDialogs() {
  const { open, setOpen, currentRow, setCurrentRow } = useDepartments()
  const queryClient = useQueryClient()

  return (
    <>
      {open === 'create' && (
        <DepartmentsMutateDrawer
          key='department-create'
          open={open === 'create'}
          onOpenChange={() => setOpen('create')}
        />
      )}

      {currentRow && (
        <>
          <DepartmentsMutateDrawer
            key={`department-update-${currentRow.id}`}
            open={open === 'update'}
            onOpenChange={() => {
              setOpen('update')
              setTimeout(() => {
                setCurrentRow(null)
              }, 100)
            }}
            currentRow={currentRow}
          />

          <ConfirmDialog
            key='department-delete'
            destructive
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 100)
            }}
            handleConfirm={() => {
              setOpen(null)
              setTimeout(() => {
                setCurrentRow(null)
              }, 100)
              toast.promise(DepartmentService.delete(currentRow.id), {
                loading: 'Excluindo departamento...',
                success: () => {
                  queryClient.invalidateQueries(listDepartmentsWithRelationsQuery);
                  return 'Departamento excluído'
                },
                error: () => {
                  queryClient.invalidateQueries(listDepartmentsWithRelationsQuery);
                  return 'Erro ao excluir departamento.'
                },
              })
            }}
            className='max-w-md'
            title={`Excluir este departamento: ${currentRow.name} ?`}
            desc={currentRow.isDefault
              ? (
                <React.Fragment>
                  Este departamento é padrão e não pode ser excluído.
                  <br />
                  <br />
                  Se deseja excluir este departamento, primeiro atribua outro departamento como padrão.
                </React.Fragment>
              )
              : (
                <React.Fragment>
                  Você está prestes a excluir o departamento {' '}
                  <strong>{currentRow.name}</strong>. <br />
                  Esta ação não pode ser revertida.
                </React.Fragment>
              )}
            disabled={currentRow.isDefault}
            confirmText='Excluir'
          />
        </>
      )}
    </>
  )
}
